import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProfileConfig } from './../../profile.config';

@Component({
  selector: 'view-profile-license',
  templateUrl: './view-profile-professional-license.component.html',
  providers: []
})

export class ViewProfileProfessionalLicenseComponent {
  @Input() viewProfileData: Object;
  profileKey: string;

  constructor() {
  }

  ngOnInit() {
    this.profileKey = ProfileConfig.getViewProfileProfessionalLicenseKey();
  }
}